<template>
  <main class="content">
    <h1>Page Not Found</h1>
    <p>The page you are looking for does not exist.</p>
    <router-link :to="{ name: 'ComLogin' }" class="link">Go to Home</router-link>
  </main>
</template>

<style lang="less" scoped>
h1 {
  text-align: center;
  font-size: 2rem;
  font-weight: @font-weight-bold;
  color: @color-primary;
}

.link {
  color: @color-secondary;
  text-decoration: underline;
  cursor: pointer;
}
</style>
